import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// L'import de ton logo est bien là !
import logoImg from './assets/logo.jpg'; 

function Landing() {
  const navigate = useNavigate();
  const [cgvAcceptees, setCgvAcceptees] = useState(false);
  const [faqOpen, setFaqOpen] = useState(null);

  // 🚀 LE MOTEUR DE REDIRECTION RÉPARÉ
  const choisirPlan = (plan) => {
    // 1. Protection légale
    if (plan.priceId && !cgvAcceptees) {
      alert("⚠️ Action requise : Veuillez cocher la case d'acceptation des conditions légales juste au-dessus des offres.");
      return;
    }

    // 2. On enregistre les infos de base
    localStorage.setItem('limiteQuestions', plan.limit);
    localStorage.setItem('planChoisi', plan.title);

    // 3. Gestion du paiement
    if (plan.priceId) {
      localStorage.setItem('pendingPriceId', plan.priceId);
      
      // On vérifie si 'type' existe pour éviter le plantage
      const isSubscription = plan.type && plan.type.includes('mois');
      localStorage.setItem('pendingPlanType', isSubscription ? "subscription" : "payment");
    } else {
      localStorage.removeItem('pendingPriceId');
      localStorage.removeItem('pendingPlanType');
    }

    // 4. Redirection vers l'inscription
    navigate('/register');
  };

  return (
    <div style={{ fontFamily: '"Inter", sans-serif', color: '#0B1F3A', background: '#FFFFFF', minHeight: '100vh' }}>
      
      {/* 🚀 BANDEAU NOUVEAUTÉ IA ACT */}
      <div style={{ background: '#f8fafc', padding: '15px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>
        <span style={{ color: '#64748b', marginRight: '15px' }}>🚀 NOUVEAU : Vous utilisez l'Intelligence Artificielle ?</span>
        <Link to="/ai-act" style={{ color: '#8b5cf6', textDecoration: 'none', fontWeight: 'bold' }}>
          Découvrez notre Audit de conformité AI Act & Deepfake
        </Link>
      </div>

      {/* HERO SECTION */}
      <header style={{ background: '#0B1F3A', color: '#FFFFFF', padding: '100px 20px', textAlign: 'center' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.1)', padding: '6px 16px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold', marginBottom: '24px', border: '1px solid rgba(255,255,255,0.2)' }}>
            RGPD · NIS2 · ISO 27001
          </div>
          <h1 style={{ fontSize: '48px', fontWeight: '800', margin: '0 0 24px 0', lineHeight: '1.2' }}>
            Savez-vous vraiment où en est votre entreprise ?
          </h1>
          <p style={{ fontSize: '20px', color: '#F5F7FA', opacity: 0.9, marginBottom: '40px' }}>
            Identifiez les référentiels qui s'appliquent à vous, mesurez vos écarts et obtenez un plan d'action priorisé. Puis suivez vos progrès dans un tableau de bord.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <button onClick={() => choisirPlan({title: 'Découverte', limit: 7, priceId: null})} style={{ padding: '16px 32px', fontSize: '18px', fontWeight: 'bold', borderRadius: '8px', background: '#6C5CE7', color: 'white', border: 'none', cursor: 'pointer', boxShadow: '0 4px 15px rgba(108, 92, 231, 0.4)' }}>
              Essai Gratuit (7 questions)
            </button>
            <a href="#offres" style={{ textDecoration: 'none' }}>
              <button style={{ padding: '16px 32px', fontSize: '18px', fontWeight: 'bold', borderRadius: '8px', background: 'transparent', color: 'white', border: '2px solid rgba(255,255,255,0.3)', cursor: 'pointer' }}>
                Voir les offres
              </button>
            </a>
          </div>
        </div>
      </header>

      {/* SOLUTION */}
      <section style={{ background: '#F5F7FA', padding: '80px 20px', textAlign: 'center' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '50px' }}>La solution : Un pilotage continu et automatisé</h2>
          <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', justifyContent: 'center' }}>
            {[ { icon: '📝', t: 'Audit Structuré', d: '15 à 90 questions ciblées selon vos enjeux.' },
               { icon: '📊', t: 'Score de Santé', d: 'Lisible et recalculé en direct après chaque action.' },
               { icon: '🎯', t: 'Plan d\'Action', d: 'Recommandations concrètes et prioritaires.' },
               { icon: '📈', t: 'Suivi Continu', d: 'Un tableau de bord qui évolue avec votre sécurité.' }
            ].map((item, i) => (
              <div key={i} style={{ flex: '1 1 200px', padding: '20px', background: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(11, 31, 58, 0.03)' }}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>{item.icon}</div>
                <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>{item.t}</h3>
                <p style={{ color: '#0B1F3A', opacity: 0.7, lineHeight: '1.5' }}>{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* NOTRE ENGAGEMENT */}
      <section style={{ padding: '80px 20px', background: '#FFFFFF', textAlign: 'center' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ display: 'inline-block', background: '#F5F7FA', color: '#6C5CE7', padding: '6px 16px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold', marginBottom: '20px', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Notre engagement d'exception et de confiance
          </div>
          <h2 style={{ fontSize: '36px', fontWeight: 'bold', color: '#0B1F3A', marginBottom: '40px' }}>
            L'excellence au service de votre conformité
          </h2>
          
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
            <img 
              src={logoImg} 
              alt="Audit Cyber Pro - Engagement et Confiance" 
              style={{ 
                maxWidth: '100%', 
                height: 'auto', 
                maxHeight: '450px', 
                borderRadius: '8px', 
                boxShadow: '0 10px 40px rgba(11, 31, 58, 0.08)' 
              }} 
            />
          </div>
        </div>
      </section>

      {/* OFFRES & TARIFS */}
      <section id="offres" style={{ background: '#0B1F3A', padding: '100px 20px', textAlign: 'center', color: 'white' }}>
        <h2 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '20px' }}>Choisissez votre niveau de protection</h2>
        
        {/* NOUVEAU COPYWRITING RGPD */}
        <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto 40px auto', padding: '0 20px' }}>
          <p style={{ fontSize: '18px', color: '#94A3B8', lineHeight: '1.6', fontWeight: '500' }}>
            <strong style={{ color: '#FFFFFF' }}>Transformez vos données en décisions stratégiques.</strong><br/>
            Un audit ultra-complet qui révèle les priorités critiques et les leviers de croissance à activer immédiatement.
          </p>
        </div>
        
        <div style={{ marginBottom: '50px', background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '8px', display: 'inline-block', maxWidth: '800px', border: cgvAcceptees ? '2px solid #2ecc71' : '1px dashed rgba(255,255,255,0.3)' }}>
          <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'flex-start', gap: '15px', fontSize: '14px', textAlign: 'left' }}>
            <input type="checkbox" checked={cgvAcceptees} onChange={(e) => setCgvAcceptees(e.target.checked)} style={{ width: '24px', height: '24px' }} />
            <span>J'accepte les Conditions Générales et je renonce à mon droit de rétractation pour accéder immédiatement aux outils de diagnostic (Art. L221-28).</span>
          </label>
        </div>

        <div style={{ marginBottom: '40px', fontSize: '20px', fontWeight: 'bold', color: '#60A5FA', letterSpacing: '2px', textTransform: 'uppercase' }}>📦 Offres à l'unité</div>
        <div style={{ display: 'flex', gap: '25px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '80px', alignItems: 'stretch' }}>
          {[
            { title: 'Découverte', price: '0€', limit: 7, type: 'gratuit', color: '#94A3B8', feats: ['7 questions', 'Score global', 'Idéal pour tester'], priceId: null },
            { title: 'Starter', price: '49€', limit: 15, type: 'unique', color: '#3B82F6', feats: ['15 questions', 'Rapport PDF', 'Bot IA (100q)'], priceId: 'price_1TTezI1KS1vyXKN3zDyF35Ri' },
            { title: 'Diagnostic Pro', price: '99€', limit: 30, type: 'unique', color: '#2563EB', feats: ['30 questions', "Plan d'action PDF", '2 rapports dynamiques'], priceId: 'price_1TTfNN1KS1vyXKN3MHwfWhuY' },
            { title: 'Audit Complet', price: '199€', limit: 50, type: 'unique', color: '#6C5CE7', badge: '🏆 EXPERTISE MAXIMALE', feats: ['50 questions', 'Analyse 360°', '5 rapports dynamiques'], priceId: 'price_1TTfRe1KS1vyXKN3pTR1ivbb' }
          ].map((plan, i) => {
            const isAuditComplet = plan.title === 'Audit Complet';
            return (
              <div key={i} style={{ 
                background: isAuditComplet ? '#1E293B' : 'white', color: isAuditComplet ? 'white' : '#0B1F3A', padding: isAuditComplet ? '40px 20px' : '30px 20px', borderRadius: '16px', width: '260px', textAlign: 'left', position: 'relative', display: 'flex', flexDirection: 'column', border: isAuditComplet ? `2px solid ${plan.color}` : '1px solid transparent', transform: isAuditComplet ? 'scale(1.05)' : 'scale(1)', boxShadow: isAuditComplet ? `0 15px 35px rgba(108, 92, 231, 0.4)` : '0 10px 30px rgba(0,0,0,0.2)', zIndex: isAuditComplet ? 10 : 1
              }}>
                {plan.badge && <div style={{ position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)', background: plan.color, color: 'white', padding: '6px 16px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', whiteSpace: 'nowrap' }}>{plan.badge}</div>}
                <h3 style={{ margin: '0 0 10px 0', fontSize: '22px' }}>{plan.title}</h3>
                <div style={{ fontSize: '36px', fontWeight: 'bold', color: plan.color, marginBottom: '20px' }}>{plan.price}</div>
                <ul style={{ listStyle: 'none', padding: 0, fontSize: '14px', marginBottom: '25px', flex: 1 }}>
                  {plan.feats.map((f, j) => <li key={j} style={{ marginBottom: '10px' }}><span style={{ color: plan.color, fontWeight: 'bold', marginRight: '8px' }}>✓</span> {f}</li>)}
                </ul>
                <button onClick={() => choisirPlan(plan)} style={{ width: '100%', padding: '15px', borderRadius: '8px', background: plan.price === '0€' ? 'transparent' : plan.color, color: plan.price === '0€' ? plan.color : 'white', border: plan.price === '0€' ? `2px solid ${plan.color}` : 'none', fontWeight: 'bold', cursor: 'pointer', opacity: (plan.priceId && !cgvAcceptees) ? 0.5 : 1 }}>
                  {plan.priceId ? "PAYER ET DÉMARRER" : "COMMENCER GRATUIT"}
                </button>
              </div>
            );
          })}
        </div>

        <div style={{ marginBottom: '40px', fontSize: '20px', fontWeight: 'bold', color: '#F59E0B', letterSpacing: '2px', textTransform: 'uppercase' }}>🔁 Abonnements</div>
        <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          {[
            { title: 'Premium', price: '290€', limit: 70, type: 'mois', color: '#F59E0B', slogan: 'Passez d’exécutant à stratège.', badge: '👉 ÉQUILIBRE VALEUR/PRIX', feats: ['5 audits complets inclus', '15 rapports dynamiques max', 'Bot IA étendu (500q)', 'Suivi de santé continu'], priceId: 'price_1TTfU51KS1vyXKN3oGoMCyH5' },
            { title: 'Elite', price: '490€', limit: 100, type: 'mois', color: '#8B5CF6', slogan: 'L’IA travaille. Vous décidez.', badge: '👑 PRESTIGE ÉLITE', feats: ['Audits illimités', 'Rapports complets illimités', "Plan d'action illimité", 'Bot IA illimité', 'Optimisation prioritaire'], priceId: 'price_1TTfWo1KS1vyXKN3HduwLOqF' }
          ].map((plan, i) => {
            const isElite = plan.title === 'Elite';
            return (
              <div key={i} style={{ 
                background: isElite ? 'linear-gradient(135deg, #1E293B 0%, #0B1F3A 100%)' : 'white', color: isElite ? 'white' : '#0B1F3A', padding: isElite ? '50px 30px' : '40px 30px', borderRadius: '16px', width: isElite ? '360px' : '330px', textAlign: 'left', position: 'relative', display: 'flex', flexDirection: 'column', border: isElite ? `4px solid ${plan.color}` : `3px solid ${plan.color}`, transform: isElite ? 'scale(1.08)' : 'scale(1)', boxShadow: isElite ? `0 25px 50px rgba(139, 92, 246, 0.4)` : '0 15px 35px rgba(0,0,0,0.2)', zIndex: isElite ? 20 : 1
              }}>
                {plan.badge && <div style={{ position: 'absolute', top: '-18px', left: '50%', transform: 'translateX(-50%)', background: isElite ? 'linear-gradient(90deg, #8B5CF6, #D946EF)' : plan.color, color: isElite ? 'white' : '#0B1F3A', padding: '8px 24px', borderRadius: '30px', fontSize: '12px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>{plan.badge}</div>}
                {plan.slogan && <div style={{ fontSize: '13px', fontWeight: '900', color: isElite ? '#D946EF' : plan.color, marginBottom: '15px', textTransform: 'uppercase' }}>— {plan.slogan}</div>}
                <h3 style={{ margin: '0 0 10px 0', fontSize: '28px' }}>{plan.title}</h3>
                <div style={{ fontSize: '48px', fontWeight: '900', color: plan.color }}>{plan.price}<span style={{ fontSize: '16px', color: isElite ? '#94A3B8' : '#7f8c8d', fontWeight: 'normal' }}>/mois</span></div>
                <ul style={{ listStyle: 'none', padding: 0, fontSize: '15px', margin: '30px 0', flex: 1, lineHeight: '1.8' }}>
                  {plan.feats.map((f, j) => <li key={j} style={{ marginBottom: '10px' }}><span style={{ color: plan.color, fontWeight: 'bold', marginRight: '10px', fontSize: '18px' }}>✓</span> {f}</li>)}
                </ul>
                <button onClick={() => choisirPlan(plan)} style={{ width: '100%', padding: '18px', borderRadius: '10px', background: isElite ? 'linear-gradient(135deg, #8B5CF6, #6D28D9)' : plan.color, color: isElite ? 'white' : '#0B1F3A', border: 'none', fontWeight: 'bold', fontSize: '16px', opacity: (plan.priceId && !cgvAcceptees) ? 0.5 : 1 }}>
                  {isElite ? "S'ABONNER À L'EXCELLENCE" : "PAYER ET DÉMARRER"}
                </button>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ background: '#0B1F3A', padding: '100px 20px', textAlign: 'center', color: 'white' }}>
        <h2 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '30px' }}>Ne laissez plus votre sécurité au hasard.</h2>
        <button onClick={() => choisirPlan({title: 'Découverte', limit: 7, priceId: null})} style={{ padding: '20px 40px', fontSize: '18px', fontWeight: 'bold', borderRadius: '8px', background: '#6C5CE7', color: 'white', border: 'none', cursor: 'pointer', boxShadow: '0 4px 15px rgba(108, 92, 231, 0.4)' }}>
          Sécuriser mon entreprise maintenant
        </button>
      </section>

    </div>
  );
}

export default Landing;